import type { CallToActionProps } from '../components/CallToAction.tsx';
import { ActionType } from './types.ts';

export const sampleCTAs: CallToActionProps[] = [
  {
    actionType: ActionType.EMPTY,
    text: 'Sample empty action',
    disabled: false,
  },
  {
    actionType: ActionType.QUESTION,
    text: 'Disabled question action',
    disabled: true,
    tooltip: 'Disabled tooltip',
    onClick: () => alert('This shouldnt show'),
  },
  {
    actionType: ActionType.REDIRECT,
    text: 'Sample redirect action',
    tooltip: 'Sample tooltip',
    disabled: false,
  },
  {
    actionType: ActionType.FUNCTION,
    text: 'action action',
    tooltip: 'Sample tooltip',
    onClick: () => alert('Why hello there'),
  },
];
